module.exports = function(bh) {
    bh.match('map-available', function(ctx) {
        process.env.NODE_ENV === 'production' && ctx.attrs({
            'data-id': '101047',
            'data-action-info': '/rest/catalog/products-available-date-quantity-ext.json',
        });
    });
};